import { makeStyles } from '@material-ui/core';



export const snackbarStyles = makeStyles((theme) => ({
    snackbarContainer: {
        
        [theme.breakpoints.between('sm', 'md')]: {
            width: '75%',
        },
        '& > div': {
            borderRadius: '3px',
        },
    },

}));



